import PropTypes from 'prop-types';
import {DYNAMIC_PAGE_GROUP_LIST, DYNAMIC_PAGE_GROUP_MONTH} from "../constants";
import CustomSelect from "../../../components/form/CustomSelect";

const DynamicPageGroupSelect = ({

                                  disabled, value, className, setValue, label, monthly, loading
                                }) => {
  const _options = monthly ? [{
    id: 1,
    value: DYNAMIC_PAGE_GROUP_MONTH,
    label: 'Last Month'
  }, ...DYNAMIC_PAGE_GROUP_LIST] : DYNAMIC_PAGE_GROUP_LIST;

  return (

    <CustomSelect onChange={setValue} value={value} title={label} titleClass="text-sm mb-1.5 font-bold"
                  options={_options} disabled={disabled} loading={loading}
                  className={className}/>
  );
};


DynamicPageGroupSelect.propTypes = {
  className: PropTypes.string,
  setValue: PropTypes.func.isRequired

};

export default DynamicPageGroupSelect;

